// Types
export var BadgeStylePropertiesByShape = {
    pill: {
        borderRadius: '180px',
    },
    square: {
        borderRadius: '4px',
    },
};
//# sourceMappingURL=BadgeStylePropertiesByShape.js.map